var $ = jQuery.noConflict();
$(document).ready(function($){

  $('.hb-slider').slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		infinite: true,
		speed: 1000,
		autoplay: true,
        fade: true,
		dots: false,
		arrow: false,
		autoplaySpeed: 6000,
        pauseOnHover: false,
	});
  
//ACCORDION
$('.add-accordion').each(function(){
	var those = $(this);
	var $first_div = '#' + $(this).find('.accordion-container:first').find('.accordion').attr('id');
	var $question_div = '#' + $(this).find('.accordion-container:first').find('.accordion-question-container').attr('id');
	var $answer_div = '#' + $(this).find('.accordion-container:first').find('.accordion-answer-container').attr('id');
	var $btn_icon = '#' + $(this).find('.accordion-container:first').find('.accordion-button-icon').attr('id');
	var $content_div = $(this).find('.accordion-container:first').addClass('accordion-container-active');

//	$($first_div).addClass('accordion-active');
//	$($question_div).addClass('question_active');
//	$($answer_div).addClass('answer_active').slideDown(300);
//	$($btn_icon).text('-');
//	$($btn_icon).removeClass('xdclose').addClass('xdopen');
	
	those.find('.accordion-question-container').click(function(){
		var that = $(this);
        var p = that.parent().attr('id');

		if( $(this).next().css('display') == 'none' ){
			those.find('.accordion').removeClass('accordion-active');
			those.find('.accordion-container').removeClass('accordion-container-active');
			those.find('.accordion-question-container').removeClass('question-active');
			those.find('.accordion-answer-container').removeClass('answer-active');
			those.find('.accordion-button-icon').text('+');
		//	those.find('.accordion-button-icon').removeClass('xdclose').addClass('xdopen');
			those.find('.accordion-answer-container').slideUp(300);

            
          
			that.parent().addClass('accordion-active');
			that.parent().parent().addClass('accordion-container-active');
			that.addClass('question-active');
			that.next().addClass('answer-active');
			that.next().slideDown(300);
			that.find('.accordion-button-icon').text('-');
		//	that.find('.accordion-button-icon').removeClass('xdopen').addClass('xdclose');

            setTimeout(function(){
                $('html, body').animate({
                  scrollTop: $('#' + p).offset().top - 90
                }, 'slow');
            },300); 
          
		} else {
			those.find('.accordion').removeClass('accordion-active');
			those.find('.accordion-container').removeClass('accordion-container-active');
			those.find('.accordion-question_container').removeClass('question-active');
			those.find('.accordion-answer_container').removeClass('answer-active');
			those.find('.accordion-button-icon').text('+');
		//	those.find('.accordion-button-icon').removeClass('xdclose').addClass('xdopen');
			those.find('.accordion-answer-container').slideUp(300);
               
		}
       
	});
});

  $('.previewCartTotals.total').find('.previewCartTotals-value').addClass('.quickCartTotals');

  $('.desc-readmore').click(function(){
      $(this).parents('.productView-container').find("#tab-product-features .toggle-content").css('display', 'block');
      $(this).parents('.productView-container').find("#tab-product-features a.toggleLink").addClass('is-open');
  });

  
  
});